var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vta93tee7a)",
    stroke: "#85C11F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.475 38.221V25.779h-5.802a26.058 26.058 0 0 0-3.126-7.533l4.102-4.102-8.803-8.803-4.102 4.102a26.353 26.353 0 0 0-7.533-3.126V.524H25.768v5.802a26.058 26.058 0 0 0-7.533 3.127L14.132 5.35 5.34 14.143l4.102 4.102a26.353 26.353 0 0 0-3.126 7.533H.524v12.444h5.802a26.058 26.058 0 0 0 3.127 7.533L5.35 49.857l8.802 8.803 4.103-4.103a26.353 26.353 0 0 0 7.533 3.127v5.802h12.443v-5.802a26.06 26.06 0 0 0 7.533-3.127l4.102 4.102 8.803-8.802-4.102-4.102a26.353 26.353 0 0 0 3.126-7.534h5.802-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 49.627c9.735 0 17.627-7.892 17.627-17.627 0-9.734-7.892-17.626-17.627-17.626-9.734 0-17.626 7.892-17.626 17.626 0 9.735 7.892 17.627 17.626 17.627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.68 24.781-7.05 7.428-3.6-3.64-3.63 3.766 7.26 7.439 10.692-11.51-3.672-3.483z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vta93tee7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.67b2be299c42cf6c6ef660d8e1610440.svg";
export { ForwardRef as ReactComponent };